import { type SVGProps } from "react";

type SparkleIconProps = SVGProps<SVGSVGElement> & {
  variant?: "gradient" | "white";
};

export function SparkleIcon({ variant = "gradient", ...props }: SparkleIconProps) {
  const fill0 = variant === "white" ? "white" : "url(#paint0_linear_4197_7240)";
  const fill1 = variant === "white" ? "white" : "url(#paint1_linear_4197_7240)";

  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0508 6.00039C10.4812 6.00039 10.8634 6.27582 10.9995 6.68416L12.4664 11.0848L16.867 12.5517C17.2754 12.6878 17.5508 13.07 17.5508 13.5004C17.5508 13.9308 17.2754 14.313 16.867 14.4491L12.4664 15.916L10.9995 20.3166C10.8634 20.725 10.4812 21.0004 10.0508 21.0004C9.62035 21.0004 9.23821 20.725 9.1021 20.3166L7.63521 15.916L3.23455 14.4491C2.82621 14.313 2.55078 13.9308 2.55078 13.5004C2.55078 13.07 2.82621 12.6878 3.23455 12.5517L7.63521 11.0848L9.1021 6.68416C9.23821 6.27582 9.62035 6.00039 10.0508 6.00039ZM10.0508 10.1627L9.37446 12.1916C9.27493 12.4902 9.04061 12.7245 8.74201 12.8241L6.71306 13.5004L8.74201 14.1767C9.04061 14.2762 9.27493 14.5106 9.37446 14.8092L10.0508 16.8381L10.7271 14.8092C10.8266 14.5106 11.0609 14.2762 11.3596 14.1767L13.3885 13.5004L11.3596 12.8241C11.0609 12.7245 10.8266 12.4902 10.7271 12.1916L10.0508 10.1627Z"
        fill={fill0}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0508 2.40039C18.309 2.40039 18.5383 2.56565 18.62 2.81065L19.4001 5.15105L21.7405 5.93118C21.9855 6.01285 22.1508 6.24213 22.1508 6.50039C22.1508 6.75865 21.9855 6.98793 21.7405 7.0696L19.4001 7.84973L18.62 10.1901C18.5383 10.4351 18.309 10.6004 18.0508 10.6004C17.7925 10.6004 17.5632 10.4351 17.4816 10.1901L16.7014 7.84973L14.361 7.0696C14.116 6.98793 13.9508 6.75865 13.9508 6.50039C13.9508 6.24213 14.116 6.01285 14.361 5.93118L16.7014 5.15105L17.4816 2.81065C17.5632 2.56565 17.7925 2.40039 18.0508 2.40039Z"
        fill={fill1}
      />
      {variant === "gradient" && (
        <defs>
          <linearGradient
            id="paint0_linear_4197_7240"
            x1="19.5585"
            y1="21.0004"
            x2="4.81389"
            y2="20.5269"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2D6EFF" />
            <stop offset="1" stopColor="#AC7FF4" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_4197_7240"
            x1="19.5585"
            y1="21.0004"
            x2="4.81389"
            y2="20.5269"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2D6EFF" />
            <stop offset="1" stopColor="#AC7FF4" />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
}
